import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchPublishedEpisodes } from '../../utils/fgtnApi';
import { formatAirDate, getFgtnEpisodePath, isProbablyMissingTableError } from '../../utils/fgtn';
import { isSupabaseConfigured } from '../../utils/supabaseClient';
import './Fgtn.css';

export default function FgtnIndexPage() {
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'FGTN Shows | Angler Built';
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!isSupabaseConfigured()) {
        setError('Episode list is not available yet.');
        setLoading(false);
        return;
      }

      try {
        const rows = await fetchPublishedEpisodes();
        if (!cancelled) setEpisodes(rows);
      } catch (err) {
        console.error('Failed to load FGTN episodes', err);
        if (!cancelled) {
          setError(
            isProbablyMissingTableError(err)
              ? 'FGTN episodes are not set up in the database yet.'
              : 'Could not load episodes right now.'
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="fgtn-page">
      <p className="fgtn-kicker">Fishing Gear & Tech News</p>
      <h1 className="fgtn-title">FGTN Shows</h1>
      <p className="fgtn-subtitle">
        Weekly links from the show. Scan the QR on stream, or browse past episodes here.
      </p>

      {loading && <div className="fgtn-status">Loading episodes…</div>}
      {!loading && error && <div className="fgtn-error">{error}</div>}
      {!loading && !error && episodes.length === 0 && (
        <div className="fgtn-empty">Episodes will show up here each week after the show notes are published.</div>
      )}

      {!loading && !error && episodes.length > 0 && (
        <div className="fgtn-episode-list">
          {episodes.map((episode) => (
            <Link
              key={episode.id}
              className="fgtn-episode-row"
              to={getFgtnEpisodePath(episode.episode_number)}
            >
              <div className="fgtn-episode-number">Ep {episode.episode_number}</div>
              <div className="fgtn-episode-row-body">
                <h2 className="fgtn-episode-row-title">{episode.title}</h2>
                <p className="fgtn-episode-row-date">{formatAirDate(episode.air_date)}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
